import { PARTNER_PAGE } from "routes/route.constant";
import Partner from "./Partner";

const route = {
  path: PARTNER_PAGE,
  element: Partner,
};

export default route;
